import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'

import { selectedNetworkAtom } from '@root/entities/network'
import { Trend } from '@root/entities/trend'
import { TableLiquidityPoolCell } from '@root/features/trade/tables/table-cell/table-lp-cell'
import { TableMakerCell } from '@root/features/trade/tables/table-cell/table-maker-cell'
import { setMakerFilterEvent } from '@root/features/trade/tables/trades-table'
import { FilterButton } from '@root/shared/ui-kit'

import type { PairHoldersTableColumnId } from '../atoms/reatom-pair-holders-column-id'
import type { PairAddress, PairModel } from '@root/entities/pair'
import type { Maker } from '@root/entities/trade'
import type { DataTableCellProps } from '@root/shared/ui-kit'

type HolderTableMakerCellProps = {
  pair: PairModel | undefined
  dataTableCell: DataTableCellProps<
    Maker.RankedMaker,
    PairHoldersTableColumnId,
    { pairAddress: PairAddress }
  >
}
export const HolderTableMakerCell = (props: HolderTableMakerCellProps) => {
  const {
    pair,
    dataTableCell: {
      model,
      column,
      value: maker,
      context: { pairAddress },
    },
  } = props
  const [filters] = useAtom(model.filters)
  const trend = Trend.of(maker.pnl)
  const [network] = useAtom(selectedNetworkAtom)
  const setFilter = useAction(setMakerFilterEvent)

  const isFilteredByThisMaker = useMemo(() => {
    const filter = filters[column.id]
    return (
      filter?.type === 'string' &&
      filter.operator === 'eq' &&
      filter.value === maker.address
    )
  }, [column.id, filters, maker.address])

  const handleFilter = () => {
    setFilter({ maker: maker.address })
  }

  if (maker.address.toLowerCase() === pairAddress.toLowerCase()) {
    return <TableLiquidityPoolCell />
  }

  return (
    <TableMakerCell
      color={Trend.match(trend, {
        Up: () => 'var(--up-9)',
        Down: () => 'var(--down-9)',
        Neutral: () => 'var(--neutral-11)',
      })}
      maker={maker}
      childrenPosition="start"
      network={network}
      pairAddress={props.dataTableCell.context.pairAddress}
      pair={pair}
      aliasUserWallet={true}
      showOwner={true}
    >
      <FilterButton onClick={handleFilter} active={isFilteredByThisMaker} />
    </TableMakerCell>
  )
}
